// extracted by mini-css-extract-plugin
module.exports = {"container":"_1JkLS_E1g1ianx0EuwKwDV"};